import styled from 'styled-components'

import BaseToggleButton from './BaseToggleButton'

const CompactButton = styled(BaseToggleButton).attrs({
  'aria-label': 'Switch to compact view',
  title: 'Compact view',
})`
  border-top-right-radius: ${props => props.theme.radii.rounded};
  border-bottom-right-radius: ${props => props.theme.radii.rounded};
`
export default CompactButton
